// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"230":"component---src-pages-index-jsx","664":"reactPlayerPreview","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"230":"35312777c44f1d1570a1","664":"f04e6c1c6bea35af7085","731":"6022bc0d8b12768a8fa1","843":"157cdb0e65fb32588f02","883":"eff12d638c1816487415"}[chunkId] + ".js";
};